import React from "react";
import "../PregledTable/PregledTable.css";
import { Table, Tooltip, Button } from "antd";
import Column from "antd/lib/table/Column";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { Row, Col } from "react-bootstrap";

export default function prikazIzvjestaja(props) {
  let dropdownData = [];

  const { izvjestajParams, dropdownFilterData, dropdownLabel } = props;

  dropdownData.push({ id: 0, name: "BEZ FILTERA" });
  dropdownFilterData.map((element) => dropdownData.push(element));

  let dropdownOptions = dropdownData.map((element) => (
    <option key={element.id} value={element.id}>
      {element.name}
    </option>
  ));
  return (
    <>
      <div className="flex-sb">
        <h5
          style={{
            lineHeight: "1.2",
            margin: "0 8px 0",
          }}
        >
          {props.izvjestajTitle}
        </h5>

        <div style={{ textAlign: "right" }}>
          <Tooltip title="Preuzmi kao XLS datoteku">
            <Button
              disabled={props.izvjestajDataList.length < 1}
              className="download_csv"
              onClick={(e) => props.printIzvjestajXlsx(e)}
              icon={<FileExcelOutlined />}
            >
              XLS
            </Button>
          </Tooltip>
          <Tooltip title="Preuzmi kao PDF datoteku">
            <Button
              disabled={props.izvjestajDataList.length < 1}
              className="download_csv"
              onClick={(e) => props.printIzvjestajPdf(e)}
              style={{ marginLeft: ".5rem" }}
              icon={<FilePdfOutlined />}
            >
              PDF
            </Button>
          </Tooltip>
        </div>
      </div>
      <Row>
        <Col>
          <div style={{ width: "320px" }}>
            <Dropdown
              hidden
              value={izvjestajParams.filter}
              onChange={props.dropdownFilterHandler}
              asProperty="select"
              map={dropdownOptions}
              text="Filtriraj izvještaj"
              id="filterIzvjestaja"
            />
          </div>
        </Col>
      </Row>

      <Table bordered dataSource={props.izvjestajData} scroll={{ x: true }}>
        {props.izvjestajHeaders.map((header, index) => (
          <Column
            title={header}
            dataIndex={index + 1}
            key={index}
            align={"center"}
          />
        ))}
      </Table>
    </>
  );
}
